import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IPage } from "@zaeper/communication-lib";
import {
  IWidgetVersionRestClient
} from "../../../../rest-clients/application-version/widget-version/i-widget-version-rest.client";
import {
  widgetVersionRestClientInjectionToken
} from "../../../../rest-clients/application-version/widget-version/widget-version-rest-client-injection-token";
import { IWidgetVersion } from "../../../../models/application-version/i-widget-version";

@Injectable()
export class WidgetVersionPageResolver implements Resolve<IPage<IWidgetVersion>> {
  constructor( @Inject( widgetVersionRestClientInjectionToken ) private readonly _widgetVersionRestClient: IWidgetVersionRestClient ) {
  }

  resolve( route: ActivatedRouteSnapshot ): Promise<IPage<IWidgetVersion>> {
    const widgetId: string | null = route.paramMap.get( 'widgetId' );

    if ( widgetId === null ) {
      return Promise.reject();
    }

    return this._widgetVersionRestClient.getWidgetVersionPage( widgetId, {
      pageNumber: 0,
      pageSize: 100
    } );
  }
}
